var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.042,
    height: 20.042
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.591 14.28l6.689-4.259-6.689-4.259zm2.43 5.762a9.7 9.7 0 01-3.883-.789A10.1 10.1 0 01.789 13.9a10.01 10.01 0 010-7.791 10.015 10.015 0 012.155-3.178A10.272 10.272 0 016.138.789a10.01 10.01 0 017.791 0 10.005 10.005 0 015.324 5.324 10.01 10.01 0 010 7.791 10.272 10.272 0 01-2.142 3.196 10.015 10.015 0 01-3.182 2.155 9.758 9.758 0 01-3.908.787z",
    fill: "#fff"
  })));
}

export default SvgPlayIcon;